import {CreateOrderTimeRequest, OrderTime, UpdateOrderTimeRequest} from "@/models/order-time";
import {assertTokenValidForMutation, handleResponse} from "@/services/service-helpers";
import log from '@/lib/logger';

const NBH_API_BASE_URL = import.meta.env.VITE_NBH_URL_ROOT;

export async function getOrderTimes(
    token: string | null, 
    orderId: string,
    sortBy?: string,
    sortOrder?: string
): Promise<OrderTime[] | void> {
    if (!token) {
        log.error("Kein Token für die Abfrage der Auftragszeiten vorhanden.");
        return Promise.reject("Kein Token vorhanden");
    }

    const params = new URLSearchParams();
    if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);
    const queryString = params.toString();
    const url = `${NBH_API_BASE_URL}/api/orders/${orderId}/times${queryString ? '?' + queryString : ''}`;

    const response = await fetch(url, {
        method: "GET",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        })
    });

    return handleResponse<OrderTime[]>(response);
}

export async function createOrderTime(
    token: string | null, 
    orderId: string, 
    request: CreateOrderTimeRequest
): Promise<OrderTime | void> {
    if (!token) {
        log.error("Kein Token für das Erstellen einer Auftragszeit vorhanden.");
        return Promise.reject("Kein Token vorhanden");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_API_BASE_URL}/api/orders/${orderId}/times`, {
        method: "POST",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }),
        body: JSON.stringify(request)
    });

    return handleResponse<OrderTime>(response);
}

export async function updateOrderTime(
    token: string | null,
    orderId: string,
    orderTimeId: string,
    request: UpdateOrderTimeRequest
): Promise<OrderTime | void> {
    if (!token) {
        log.error("Kein Token für das Aktualisieren einer Auftragszeit vorhanden.");
        return Promise.reject("Kein Token vorhanden");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_API_BASE_URL}/api/orders/${orderId}/times/${orderTimeId}`, {
        method: "PUT",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }),
        body: JSON.stringify(request)
    });

    return handleResponse<OrderTime>(response);
}

export async function deleteOrderTime(
    token: string | null,
    orderId: string,
    orderTimeId: string
): Promise<void> {
    if (!token) {
        log.error("Kein Token für das Löschen einer Auftragszeit vorhanden.");
        return Promise.reject("Kein Token vorhanden");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_API_BASE_URL}/api/orders/${orderId}/times/${orderTimeId}`, {
        method: "DELETE",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        })
    });

    return handleResponse<void>(response);
}